<template>
  <div class="row">
    <div class="col-12">
      <div class="separator">
        <div class="text">
          {{ text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomSeparator',
  meta: {
    description: 'Componente común separador, personalizado con título.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    text: {
      type: String,
      default: '',
      meta: {
        description: 'Título mostrado en el componente ',
        example: 'Texto requerido',
      },
    },
  },
};
</script>

<style scoped>
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
  font: 700 14px/17px Lato;
}
.separator .text {
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 21px;
  padding: 5px 16px;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #b5c3bc;
}
.separator::before {
  margin-right: 15px;
}
.separator::after {
  margin-left: 15px;
}
</style>
